
import Library from './Library'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faBars,
  faStar,
  faBox,
  faMobileNotch,
  faAddressCard,
  faCircleDollar,
  faBullseyeArrow,
  faRocket,
  faMoneyBills,
  faMagnifyingGlassChart,
  faBullseyePointer,
} from '@fortawesome/pro-regular-svg-icons'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'

library.add(faBars)
library.add(faTimes)
library.add(faStar)
library.add(faCircleCheck)
library.add(faCircleXmark)
library.add(faBox)
library.add(faMobileNotch)
library.add(faAddressCard)
library.add(faCircleDollar)
library.add(faBullseyeArrow)
library.add(faRocket)
library.add(faMoneyBills)
library.add(faMagnifyingGlassChart)
library.add(faBullseyePointer)

config.autoAddCss = false
export default {
  props: {
    name: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    fontAwesome: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    FontAwesomeIcon,
  },

  data() {
    return {
      icon: null,
    }
  },

  computed: {
    isFontAwesomeIcon() {
      return this.fontAwesome.length === 0 ? false : true
    },

    fontAwesomeIcon() {
      const icon = this.fontAwesome

      return icon
    },
  },

  created() {
    if (this.isFontAwesomeIcon) this.icon = this.fontAwesomeIcon
    else this.icon = Library[this.name]
  },
}
